var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ModuleContainer",
    _vm._b(
      {
        scopedSlots: _vm._u([
          {
            key: "btn",
            fn: function () {
              return [
                _c(
                  "MapControlButton",
                  {
                    attrs: {
                      icon: "",
                      title: !_vm.isFullScreen
                        ? _vm.$map.trans("map.action.fullscreen-control-enter")
                        : _vm.$map.trans("map.action.fullscreen-control-exit"),
                    },
                    on: { click: _vm.onToggleFullScreen },
                  },
                  [
                    _c("SvgIcon", {
                      attrs: {
                        size: 18,
                        type: "mdi",
                        path: _vm.isFullScreen
                          ? _vm.path.exitFullscreen
                          : _vm.path.fullscreen,
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }